$successDark: #56a32f;
$successLight: #edfeed;
$successBorder: #7cb851;

$errorDark: #a32f30;
$errorLight: #FEF2EDFF;
$errorBorder: #ff7878;

$messageDark: #000000;
$messageLight: #f8f8f8;
$messageBorder: #bababa;

$warningDark: #713f12;
$warningLight: #fefce8;
$warningBorder: #eab308;

.container {
  padding: 1em 1em;
  display: flex;
  gap: 1em;

  border-radius: var(--border-radius);
  border: 1px solid;

  &.success {
    border-color: $successBorder;
    background-color: $successLight;

    .title, .icon {
      color: $successDark;
    }

    .icon > span {
      border-color: $successDark;
    }
  }

  &.error {
    border-color: $errorBorder;
    background-color: $errorLight;

    .title, .icon {
      color: $errorDark;
    }

    .icon > span {
      border-color: $errorDark;
    }
  }

  &.message {
    border-color: $messageBorder;
    //background-color: $messageLight;

    .title, .icon {
      color: $messageDark;
    }

    .icon > span {
      border-color: $messageDark;
    }
  }

  &.warning {
    //p-4 rounded-lg border border-yellow-500 bg-yellow-50 text-yellow-900
    border-color: $warningBorder;
    background-color: $warningLight;

    &, .title, .icon {
      color: $warningDark;
    }

    .icon > span {
      border-color: $warningDark;
    }

  }

  /// Icon

  .icon {

    text-align: center;

    & > span {
      padding: 4px;
    }

    &.round {
      margin-top: 5px;

      span {
        border: 2px solid;
        border-radius: 100%;
        padding: 2px;

      }
    }
  }

  .texts {

    display: flex;
    flex-direction: column;
    gap: 0.5em;
    text-align: left;

    .title {
      font-weight: bold;
    }
  }
}